import { render } from "./PersonalSection.vue?vue&type=template&id=7f61c212"
import script from "./PersonalSection.vue?vue&type=script&lang=js"
export * from "./PersonalSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__